// extracted by mini-css-extract-plugin
export var childrenContainer = "_b9-0";
export var virtualScrollArea = "_b9-1";